import React from 'react'

const Footer = () => {
  return (
    <div className='Footer'>
        <h5 className='Footer-h5'>Copyright © 2026 <span className='Footer-red'>Noe Aviles</span>. All Rights Reserved.</h5>
    </div>
  )
}

export default Footer